export default __webpack_public_path__ + "ef407e6400dba26a627619d5c4aa9179.svg";